@if (!setupCompleted()) {
  <jenz-first-time-setup-dialog (setupCompleted)="onSetupCompleted()" />
} @else {
  <router-outlet></router-outlet>
}

<!-- Overlay spinner -->
<jenz-spinner />
<p-toast />
<jenz-confirmation-dialog />
